module.exports = __webpack_public_path__ + "img/banner_wa@2x.6cf06e48.png";